import type { BaseBlock } from '~/types/blocks';
import type {
  FlatNavigation,
  FlatNavigationItem,
  TreeNavigation,
} from '~/types/navigation';

const usePageStore = defineStore('page', () => {
  const treeNavigation = ref<TreeNavigation | null>(null);
  const flatNavigation = ref<FlatNavigation | null>(null);
  const navigationItem = ref<FlatNavigationItem | null>(null);
  const blocks = ref<BaseBlock[]>([]);
  const headerColor = ref<'light' | 'dark'>('dark');
  const showENLocale = ref(false);
  const headerType = ref<'default' | 'business'>('default');

  return {
    treeNavigation,
    flatNavigation,
    navigationItem,
    blocks,
    headerColor,
    showENLocale,
    headerType,
  };
});

export default usePageStore;
